import constate from 'constate'
import {
  Currency,
  Region,
  regionCityOptionsMapping, regionCnCityOptionsMapping,
  regionLocalCurrencyMapping,
} from '@/common/types/region-config.def.ts'
import { filter, isNil, uniq } from 'lodash-es'

type ContractRegionConfigProviderProps = {
  region: Region
}
export const [ContractRegionConfigProvider, useContractRegionConfig] = constate(({
  region,
}: ContractRegionConfigProviderProps) => {
  return {
    currencyOptions: uniq(filter([regionLocalCurrencyMapping[region], Currency.USD], x => !isNil(x))),
    pmCurrencyOptions: uniq(filter([Currency.USD, regionLocalCurrencyMapping[region]], x => !isNil(x))),
    cityOptions: regionCityOptionsMapping[region],
    cnCityOptions: regionCnCityOptionsMapping[region],
  }
})